/* eslint-disable */
import Vue from 'vue'
import store from '@/store/index'
import router from '@/router/index'

class Widget {
  device:Object = {}
  parentLocation:any = {}
  lobbySession:any = {}
  storage:any = {}
  countries:any = require('@/resources/json/countries.json')
  history:Object[] = []

  clearHistory () {
    this.history = []
  }

  finishPostMessage () {
    window.parent.postMessage('ocularWidget.ocularCallEnded()', '*')
  }

  setLobbySession (params:any) {
    store.state.lobbySession = {
      id: params.get('ocularSessionId'),
      config: {
        camera: true,
        microphone: true,
        screen: false
      }
    }
  }

  setLinkSession (params: any) {
    const linkStatus = params.get('ocularLinkStatus') ?? null

    // if (!linkStatus) {
    //   return false
    // }

    store.state.linkSession = {
      id: params.get('ocularLinkSessionId'),
      status: linkStatus,
      customer: JSON.parse(params.get('ocularCustomer')),
      config: {
        camera: true,
        microphone: true,
        screen: false
      }
    }
  }

  getOrganizationSettings () {
    const widget = <any> store.state.widget.data
    const settings = widget?.organization?.settings

    return {
      rating: {
        limit: settings?.rating?.limit ?? 10,
        start: settings?.rating?.start ?? 1,
      }
    }
  }

  setOcularStreaming (params:any) {
    store.state.rooms.item.data._id = params.get('ocularStreaming')
  }

  setParentLocation () {
    const params = new URLSearchParams(location.search)

    this.parentLocation = {
      title: params.get('title'),
      hostname: params.get('hostname'),
      origin: params.get('origin'),
      pathname: params.get('pathname'),
      href: params.get('href'),
      search: params.get('search'),
      hash: params.get('hash')
    }

    if (params.get('organizationCode')) {
      this.parentLocation.organizationCode = params.get('organizationCode')
    }

    if (params.get('ocularSessionId')) {
      this.setLobbySession(params)
    } else if (params.get('ocularLinkSessionId') && params.get('ocularCustomer')) { // No es necesario enviar el customer.
      this.setLinkSession(params)
    } else if (params.get('ocularStreaming')) {
      this.setOcularStreaming(params)
    }

    if (params.get('embed')) {
      store.state.widget.embedMode = (params.get('embed') === 'true')
    }

    store.state.widget.code = params.has('ocularWidgetCode') ? params.get('ocularWidgetCode') : null

    store.state.parentLocation = this.parentLocation

    Vue.prototype.$storage.finishStorage()
  }

  endsWith (string:any, searchString:string):boolean {
    return string.at(-1) === searchString
  }

  urlOrigin = () => {
    if (!this.parentLocation.hostname) {
      return null
    }

    const hostname = !this.parentLocation.hostname.indexOf('www') ? this.parentLocation.hostname.substring(4) : this.parentLocation.hostname
    let urlOrigin = `${hostname}${this.parentLocation.pathname}`
    urlOrigin = this.endsWith(urlOrigin, '/') ? urlOrigin : `${urlOrigin}/`
    urlOrigin += `${this.parentLocation.search}${this.parentLocation.hash}`

    return urlOrigin
  }

  getDevice () {
    const userAgent = navigator.userAgent
    const lowerUserAgent = userAgent.toLowerCase()

    const mobile = (lowerUserAgent.indexOf('mobile') != -1)
    let browserName, so

    if (lowerUserAgent.indexOf('edg/') != -1) {
      browserName = 'Microsoft Edge'
    } else if (lowerUserAgent.indexOf('opr/') != -1 || lowerUserAgent.indexOf('opera/') != -1) {
      browserName = 'Opera'
    } else if (lowerUserAgent.indexOf('chrome/') != -1 || lowerUserAgent.indexOf('crios/') != -1) {
      browserName = 'Google Chrome'
    } else if (lowerUserAgent.indexOf('safari/') != -1) {
      browserName = 'Apple Safari'
    } else if (lowerUserAgent.indexOf('firefox') != -1) {
      browserName = 'Mozilla Firefox'
    }

    /** SO */
    if (lowerUserAgent.indexOf('win') != -1 || lowerUserAgent.indexOf('windows') != -1) {
      so = 'Windows'
    } else if (lowerUserAgent.indexOf('android') != -1) {
      so = 'Android'
    } else if (lowerUserAgent.indexOf('linux') != -1) {
      so = 'Linux'
    } else if (lowerUserAgent.indexOf('iphone') != -1) {
      so = 'iPhone'
    } else if (lowerUserAgent.indexOf('mac os') != -1 || lowerUserAgent.indexOf('macintosh') != -1) {
      so = 'MacOS'
    }

    this.device = {
      userAgent,
      mobile,
      browserName,
      so,
      timeZone: Intl.DateTimeFormat().resolvedOptions().timeZone
    }

    return this.device
  }

  setBuyOrderSessionId (reset:Boolean = false) {
    this.storage = store.state.storage
    window.parent.postMessage(`ocularWidget.setBuyOrderSessionId(${reset ? null : this.storage.room.session.id})`, '*')
    return 'setBuyOrderSessionId success'
  }

  setSessionCammerVar (user:any) {
    window.parent.postMessage(`ocularWidget.setSessionCammerVar(${JSON.stringify(user)})`, '*')
    return 'setSessionCammerVar success'
  }

  reTry () {
    window.parent.postMessage('ocularWidget.reTry()', '*')
    return 'reTry success'
  }

  maximizeToggler (maximized = null) {
    store.state.widget.maximized = maximized !== null ? maximized : !store.state.widget.maximized

    if (!store.state.widget.maximized) {
      this.minimize()
    } else {
      this.maximize()
    }
  }

  minimize () {
    store.state.widget.maximized = false
    window.parent.postMessage('ocularWidget.minimize()', '*')
    return 'minimize success'
  }

  maximize () {
    store.state.widget.maximized = true
    window.parent.postMessage('ocularWidget.maximize()', '*')
    return "maximize success"
  }

  toggle (show = null) {
    const storage:any = store.state.storage
    if (show === null) {
      window.parent.postMessage(Vue.prototype.$organization.parentToggle() && !storage.room.session.id ? 'ocularWidget.parentToggle()' : 'ocularWidget.toggle()', '*')
    } else {
      window.parent.postMessage(Vue.prototype.$organization.parentToggle() && !storage.room.session.id ? `ocularWidget.parentToggle(${show})` : `ocularWidget.toggle(${show})`, '*')
    }

    return "toggle success"
  }

  show (all:boolean, init:boolean = false) {
    window.parent.postMessage(`ocularWidget.show(${all}, ${init})`, '*')
    return `show${!!all ? 'All' : ''} Success`
  }

  hide () {
    window.parent.postMessage('ocularWidget.hide()', '*')
    return "hide success"
  }

  closeEvent () {
    window.parent.postMessage('ocularWidget.closeEvent()', '*')
    return "closeEvent success"
  }

  minimizeEvent () {
    window.parent.postMessage('ocularWidget.emitMessage("minimized")', '*')
    return "closeEvent success"
  }

  emitEvent (event: string, data: any = null) {
    window.parent.postMessage(`ocularWidget.emitMessage("${event}", ${JSON.stringify(data)})`, '*')
    return "emitEvent success"
  }

  setDefaultConfig (config: any = {}) {
    window.parent.postMessage(`ocularWidget.setDefaultConfig(${JSON.stringify(config)})`, '*')
    return "config set success"
  }

  showPopUpContent (innerHtml:string = '', popUpSound:boolean = true, popUpHandler:any = null) {
    window.parent.postMessage(`ocularWidget.setPopUpContent(${JSON.stringify(innerHtml)})`, '*')
    window.parent.postMessage(`ocularWidget.showPopUp(${true}, ${popUpSound}, ${JSON.stringify(popUpHandler)})`, '*')
    return "popup content set success"
  }

  align (align: string = '') {
    window.parent.postMessage(`ocularWidget.align(${JSON.stringify(align)})`, '*')
    return "align success"
  }

  goToRoute (path:any) {
    router.replace({ path })
  }
}
export default new Widget()
Vue.prototype.$widget = new Widget()
const widgetPlugin = <any> new Widget()

const receiver = (event: any) => {
  const message = event.data;

  if (!message || typeof message !== 'string' || message.includes('webpack')) {
    return false;
  }

  const expression = message.split('(');
  const keyFunctionName = expression[0];
  const dataString = message.slice(`${keyFunctionName}(`.length, -1);

  const func = keyFunctionName.split('.')[1];
  const params = JSON.parse(`[${dataString}]`);

  try {
    widgetPlugin[func](...params);
  } catch (error) {
    // console.error(`Función ${keyFunctionName} no encontrada o no es una función válida.`);
  }
}

window.addEventListener('message', receiver, false);
